/**
 * Debounce utility.
 *
 * NOTE: The React hook `useDebounce` in ssm-web5 is NOT included here
 * because it depends on React hooks. This is the plain-function version.
 */

/**
 * Create a debounced version of a callback that delays invocation until
 * `wait` milliseconds have elapsed since the last call.
 *
 * @param {Function} callback
 * @param {number} wait — delay in milliseconds
 * @returns {Function}
 */
export default function debounce(callback, wait) {
    let timerId;
    return (...args) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            callback(...args);
        }, wait);
    };
}

/**
 * Ensure a callback runs only after the remaining time needed to reach a
 * minimum elapsed duration.
 *
 * @param {Object} params
 * @param {number} params.start
 * @param {number} params.diffTime
 * @param {Function} params.callback
 * @returns {void}
 */
export function debounceContinue({ start, diffTime, callback }) {
    const end = Date.now();
    const duration = end - start;

    if (duration < diffTime) {
        const remaining = diffTime - duration;
        setTimeout(() => {
            callback();
        }, remaining);
    } else {
        callback();
    }
}
